<template>
  <div :class="[baseCss, 'cursor-wait']" :style="{zIndex}" v-if="visible">
    <icon :provider="iconProvider" name="loading" :class="['animate-spin']" :color="spinnerColor" :color-lightness="spinnerColorLightness" :style="{fontSize: `${spinnerSize}em`}" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'LoadingOverlay',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('loading-overlay', ['select-none', 'outline-none', 'text-center', 'fixed', 'top-0', 'left-0', 'w-screen', 'h-screen'])
    }
  },
  props: {
    zIndex: {
      type: Number,
      default: 10000
    },
    visible: {
      type: Boolean
    },
    spinnerSize: {
      type: [String, Number],
      default: 4
    },
    spinnerColor: {
      type: String,
      default: 'gray'
    },
    spinnerColorLightness: {
      type: [Number, String],
      default: 500,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    }
  }
}
</script>
<style>
.bcq-loading-overlay
{
  background: var(--semi-transparent-light);
  line-height: 100vh;
}

.bcq-ui-theme-dark .bcq-loading-overlay
{
  background: var(--semi-transparent-dark);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/loading-overlay/loading-overlay.vue